import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/table';
import { useTable, Column } from 'react-table';
import { Tag } from 'components/tag';
import { Colors } from 'utils/misc';
import { Copyable } from 'components/copyable';
import { useHistory } from 'react-router-dom';
import { ContentFilterGroupsScreenQuery } from 'graphql/types';
import { buildRoute } from 'utils/routes';

const colors: Colors[] = [
  'gray',
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'dark-blue',
  'indigo',
  'purple',
  'pink',
  'rose',
];

type FilterGroupsTableData = {
  id: string;
  title: string;
  contentTag: {
    id: string;
    name: string;
    color: Colors;
  };
};

const contentFilterGroupsTableColumns: Column<FilterGroupsTableData>[] = [
  {
    Header: 'ID',
    accessor: 'id',
    Cell: (cell) => {
      return (
        <Copyable text={cell.value}>
          {(copied) => (
            <pre className="text-sm cursor-pointer text-slate-500">
              {copied ? 'Copied' : cell.value.slice(-6)}
            </pre>
          )}
        </Copyable>
      );
    },
  },
  {
    Header: 'Title',
    accessor: 'title',
  },
  {
    Header: 'Content Category',
    accessor: 'contentTag',
    Cell: (cell) => {
      return (
        <Tag size="small" color={cell.value.color}>
          {cell.value.name}
        </Tag>
      );
    },
  },
];

export const FilterGroupsTable = ({
  filterGroups,
  contentTags,
}: {
  filterGroups: ContentFilterGroupsScreenQuery['contentFilterGroups'];
  contentTags: ContentFilterGroupsScreenQuery['contentTags'];
}) => {
  const history = useHistory();

  const mapToColor = contentTags?.map((tag, i) => ({
    name: tag.name,
    color: colors[i],
  }));
  const filterGroupsWithTagColor = filterGroups?.map((fg) => {
    return {
      id: fg.id,
      title: fg.title,
      contentTag: {
        id: fg?.contentTag?.id ?? '',
        name: fg?.contentTag?.name ?? '',
        color:
          mapToColor?.find((ct) => ct.name === fg?.contentTag?.name)?.color ??
          'gray',
      },
    };
  });

  const tableInstance = useTable({
    columns: contentFilterGroupsTableColumns,
    data: filterGroupsWithTagColor ?? [],
  });

  return (
    <Table tableInstance={tableInstance}>
      <TableHead />
      <TableBody>
        {tableInstance.rows.map((row) => {
          tableInstance.prepareRow(row);
          return (
            <TableRow key={row.id} row={row}>
              {row.cells.map((cell) => (
                <TableCell
                  key={`${cell.row.original.id}-${cell.column.id}`}
                  cell={cell}
                  onClick={() => {
                    history.push(
                      buildRoute.contentFilterGroup(cell.row.original.id),
                    );
                  }}
                />
              ))}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
